// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 600px) {
  .r3h7nsB0Fiadzk {
    margin-left: 16px;
  }
}
.R1QRX_OYDTy2hg {
  width: 100%;
  text-align: center;
}
.IjvBaVHxUPfzia {
  width: 370px;
  max-width: 80%;
  padding: 24px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"directorySearchEmptyContainer": `r3h7nsB0Fiadzk`,
	"directorySearchNoResults": `R1QRX_OYDTy2hg`,
	"emptySearchImage": `IjvBaVHxUPfzia`
};
export default ___CSS_LOADER_EXPORT___;
